import React, { useEffect, useState } from "react";
import { Button, RadioGroup } from "@ts-digital/vrc";

import "./style.css";
import FormElement from "../../preCog/accountantContent/filter/formElement";
import { Popconfirm, Select, Upload } from "antd";
import { VaporDatePicker, VaporInput } from "../../vapor";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { startDownloadData } from "../../../libs/utils";
import { prepareValidationDocument } from "../utils";
import { TimedOverflowNotification } from "@ts-digital/arc/antd/TimedOverflowNotification";
import { generateValidationDocument, uploadValidationDocument } from "../../../store/actions/validation";

const StudioCertificationForm = ({ data, id, onCancel, onConfirm }) => {
  const intl = useIntl();
  const user = useSelector((state) => state.user);
  const [body, setBody] = useState({
    name: user?.profile?.firstName || "",
    surname: user?.profile?.lastName || "",
    consent1: null,
    consent2: null,
    date: moment(),
    city: data?.citta,
    accountantId: id,
  });

  const [step1Filled, setStep1Filled] = useState(false);
  const [step1Completed, setStep1Completed] = useState(false);
  const [step2Loading, setStep2Loading] = useState(false);
  const [step3Loading, setStep3Loading] = useState(false);
  const [step3Completed, setStep3Completed] = useState(false);
  const [step2Completed, setStep2Completed] = useState(false);
  const [allStepFilled, setAllStepFilled] = useState(false);

  const [file, setFile] = useState(null);

  const [error, setError] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    setStep1Filled(false);
    setAllStepFilled(false);
  }, []);

  useEffect(() => {
    setBody({ ...body, accountantId: id });
  }, [id]);

  useEffect(() => {
    if (step1Completed && step2Completed && file?.status === "done") {
      setAllStepFilled(true);
    } else {
      setAllStepFilled(false);
    }
  }, [file]);

  useEffect(() => {
    // step1 check
    if (body?.name && body?.surname && body?.office && body?.city && body?.date && body?.consent1 !== null && body?.consent2 !== null) {
      setStep1Filled(true);
    }
  }, [body]);

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const generateDocument = () => {
    setStep2Loading(true);
    let bodyToGenerateDocument = prepareValidationDocument(body, data);
    if (!bodyToGenerateDocument) {
      setStep2Loading(false);
      setError({ message: intl.formatMessage({ id: "validation.error.message" }), title: intl.formatMessage({ id: "validation.error.title" }) });
    } else {
      bodyToGenerateDocument.corporateOffice = intl.formatMessage({ id: bodyToGenerateDocument.corporateOffice });
    }

    dispatch(generateValidationDocument(bodyToGenerateDocument, id))
      .then((res) => {
        setStep2Loading(false);
        setStep2Completed(true);
        startDownloadData({ content: res?.contract, filename: "tsDigitalContract.pdf" });
      })
      .catch((err) => {
        setStep2Loading(false);
        setError({ message: intl.formatMessage({ id: "validation.error.message" }), title: intl.formatMessage({ id: "validation.error.title" }) });
      });
  };

  const confirmSubmit = () => {
    setStep3Loading(true);
    dispatch(uploadValidationDocument(file, data)).then(() => {
      setStep3Loading(false);
      setStep3Completed(true);
    });
  };

  const handleUpload = (fileItem) => {
    if (fileItem?.status === "done") {
      let reader = new FileReader();
      // Fix to resolve issue when upload validation document and can't see it in backoffice
      reader.onload = (e) => {
        fileItem.base64 = e.target.result?.split("pdf;base64,")[1];
      };
      reader.readAsDataURL(fileItem.originFileObj);
      setFile(fileItem);
    }
  };

  if (step3Completed) {
    return (
      <div className="dbox-validation-feedback-container">
        <div className="dbox-validation-feedback-icon">
          <FontAwesomeIcon icon={["far", "check-circle"]} />
        </div>
        <div className="dbox-validation-feedback-title">
          <h1>
            <FormattedMessage id="validation.feedback.title" />
          </h1>
        </div>
        <div className="dbox-validation-feedback-message">
          <FormattedMessage id="validation.feedback.message" />
        </div>
        <div className="dbox-validation-feedback-btn">
          <Button size="small" onClick={onConfirm}>
            <FormattedMessage id="validation.feedback.btn" />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <section className="ant-layout validation-page-container">
      {error && (
        <TimedOverflowNotification
          duration={4000}
          onClose={() => {
            setError(null);
          }}
          title={error?.title}
          variant={"error"}
        >
          {error?.message}
        </TimedOverflowNotification>
      )}
      <div className="c-accordion-stepper v-validate-company">
        <div className="ant-collapse ant-collapse-icon-position-left">
          <div
            className={
              "ant-collapse-item ant-collapse-item-disabled ant-collapse-no-arrow" + (step1Completed ? " stepper-disabled-panel" : " ant-collapse-item-active")
            }
          >
            <div className="ant-collapse-header" role="button" tabIndex="-1" aria-expanded="true">
              <div className="c-accordion-panel-header ">
                <h1>
                  <FormattedMessage id="validation.form.1.title" />
                </h1>
                <div>
                  <p>
                    <FormattedMessage id="validation.form.1.subtitle" />
                  </p>
                  <p>
                    <FormattedMessage id="validation.form.1.formTitle" />
                  </p>
                </div>
              </div>
            </div>
            <div className="ant-collapse-content ant-collapse-content-active">
              <div className="ant-collapse-content-box">
                <form className="sc-fpdzYq fmcuxS">
                  <FormElement label={`${intl.formatMessage({ id: "validation.data.name" })}:`} style={{ minWidth: 350, marginBottom: 24 }}>
                    <VaporInput
                      disabled={step1Completed}
                      readOnly={step1Completed}
                      autoFocus
                      value={body?.name}
                      onChange={(e) => {
                        !step1Completed && setBody({ ...body, name: e.target.value?.toUpperCase() });
                      }}
                      style={{ width: "100%" }}
                    />
                  </FormElement>
                  <FormElement label={`${intl.formatMessage({ id: "validation.data.surname" })}:`} style={{ minWidth: 350, marginBottom: 24 }}>
                    <VaporInput
                      disabled={step1Completed}
                      readOnly={step1Completed}
                      value={body?.surname}
                      onChange={(e) => {
                        !step1Completed && setBody({ ...body, surname: e.target.value?.toUpperCase() });
                      }}
                      style={{ width: "100%" }}
                    />
                  </FormElement>
                  <FormElement label={`${intl.formatMessage({ id: "validation.data.office" })}:`} style={{ minWidth: 350, marginBottom: 24 }}>
                    <Select
                      // allowClear
                      // getPopupContainer={trigger => trigger.parentNode}
                      style={{ width: "100%" }}
                      placeholder={""}
                      value={body?.office}
                      disabled={step1Completed}
                      onChange={(value) => {
                        !step1Completed && setBody({ ...body, office: value });
                      }}
                    >
                      <Select.Option value={1}>
                        <FormattedMessage id="validation.offices.1" defaultMessage={"Titolare"} />
                      </Select.Option>
                      <Select.Option value={2}>
                        <FormattedMessage id="validation.offices.2" defaultMessage={"Legale rappresentante"} />
                      </Select.Option>
                      <Select.Option value={3}>
                        <FormattedMessage id="validation.offices.3" defaultMessage={"Procuratore"} />
                      </Select.Option>
                    </Select>
                  </FormElement>
                  <FormElement label={`${intl.formatMessage({ id: "validation.data.city" })}:`} style={{ minWidth: 350, marginBottom: 24 }}>
                    <VaporInput
                      disabled={step1Completed}
                      readOnly={step1Completed}
                      value={body?.city}
                      onChange={(e) => {
                        !step1Completed && setBody({ ...body, city: e.target.value });
                      }}
                      style={{ width: "100%" }}
                    />
                  </FormElement>
                  <FormElement label={`${intl.formatMessage({ id: "validation.data.date" })}:`} style={{ minWidth: 170, marginBottom: 24 }}>
                    <VaporDatePicker
                      locale={user?.profile?.language === "es-ES" ? "es" : null}
                      disabled={step1Completed}
                      value={body?.date}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      onChange={(date, dateValue) => {
                        !step1Completed && setBody({ ...body, date: date });
                      }}
                      style={{ width: "100%" }}
                    />
                  </FormElement>
                </form>
                <div style={{ margin: "0px 110px 0px 70px" }} className="sc-ksfqlt clcvPH">
                  <div>
                    <div
                      style={{
                        marginBottom: "20px",
                        marginTop: "15px",
                        fontWeight: "bold",
                        color: "rgb(0, 0, 0)",
                      }}
                    >
                      <span>
                        <a
                          style={{ color: "rgb(0, 0, 0)", textDecoration: "underline" }}
                          href="https://tc.teamsystem.com/InformativaPrivacyTSDigital.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FormattedMessage id="validation.form.1.consentLink" />
                        </a>{" "}
                        <FormattedMessage id="validation.form.1.consentTitle" />
                      </span>
                    </div>
                    <div>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontWeight: "bold",
                        }}
                      >
                        <FormattedMessage id="validation.form.1.consent1" />
                      </span>
                      <div className="validation-consent">
                        <RadioGroup
                          className=""
                          value={body?.consent1}
                          onChange={(e) => {
                            !step1Completed && setBody({ ...body, consent1: e.target.value });
                          }}
                          options={[
                            {
                              label: intl.formatMessage({ id: "generic.consentYes" }),
                              value: "yes",
                              disabled: step1Completed,
                            },
                            {
                              label: intl.formatMessage({ id: "generic.consentNo" }),
                              value: "no",
                              disabled: step1Completed,
                            },
                          ]}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: 24 }}>
                      <span
                        style={{
                          color: "rgb(0, 0, 0)",
                          fontWeight: "bold",
                        }}
                      >
                        <FormattedMessage id="validation.form.1.consent2" />
                      </span>
                      <div className="validation-consent">
                        <RadioGroup
                          value={body?.consent2}
                          onChange={(e) => {
                            !step1Completed && setBody({ ...body, consent2: e.target.value });
                          }}
                          options={[
                            {
                              label: intl.formatMessage({ id: "generic.consentYes" }),
                              value: "yes",
                              disabled: step1Completed,
                            },
                            {
                              label: intl.formatMessage({ id: "generic.consentNo" }),
                              value: "no",
                              disabled: step1Completed,
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    "-webkit-box-pack": "end",
                    justifyContent: "flex-end",
                    margin: "0px 110px 0px 70px",
                  }}
                >
                  <Button onClick={() => setStep1Completed(true)} disabled={!step1Filled || step1Completed}>
                    <FormattedMessage id="validation.form.1.btn" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              "ant-collapse-item ant-collapse-item-disabled ant-collapse-no-arrow" +
              (step2Completed ? " stepper-disabled-panel" : step1Completed ? " ant-collapse-item-active" : "")
            }
          >
            <div className="ant-collapse-header" role="button" tabIndex="-1" aria-expanded={step1Completed ? "true" : "false"}>
              <div className="c-accordion-panel-header ">
                <h1>
                  <FormattedMessage id="validation.form.2.title" />
                </h1>
                <FormattedMessage id="validation.form.2.subtitle" />
              </div>
            </div>
            {step1Completed && (
              <div className="ant-collapse-content ant-collapse-content-active">
                <div className="ant-collapse-content-box">
                  <div
                    style={{
                      display: "flex",
                      "-webkit-box-pack": "justify",
                      justifyContent: "space-between",
                      margin: "0px 110px 0px 70px",
                    }}
                  >
                    <Button
                      disabled={step2Completed || step2Loading}
                      onClick={() => {
                        generateDocument();
                      }}
                    >
                      <FormattedMessage id="validation.form.2.btn" />{" "}
                      {step2Loading && <FontAwesomeIcon style={{ marginLeft: 8, fontSize: 16 }} spin icon={["far", "circle-notch"]} />}
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={"ant-collapse-item ant-collapse-no-arrow" + (step2Completed ? " ant-collapse-item-active" : " ant-collapse-item-disabled")}>
            <div className="ant-collapse-header" role="button" tabIndex="-1" aria-expanded={step2Completed ? "true" : "false"}>
              <div className="c-accordion-panel-header ">
                <h1>
                  <FormattedMessage id="validation.form.3.title" />
                </h1>
                <FormattedMessage id="validation.form.3.subtitle" />
              </div>
            </div>
            {step2Completed && (
              <div className="ant-collapse-content ant-collapse-content-active">
                <div className="ant-collapse-content-box">
                  <div
                    style={{
                      paddingLeft: "64px",
                      paddingBottom: "20px",
                    }}
                  >
                    <Upload
                      customRequest={dummyRequest}
                      action={() => {}}
                      disabled={step3Loading}
                      onRemove={() => {
                        setFile(null);
                        setAllStepFilled(false);
                      }}
                      value={file}
                      maxCount={1}
                      accept="application/pdf"
                      onChange={(e) => {
                        handleUpload(e?.file);
                      }}
                    >
                      <Button disabled={step3Loading}>
                        <FormattedMessage id="validation.form.3.btn" />
                      </Button>
                    </Upload>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="ant-collapse-item ant-collapse-item-active ant-collapse-no-arrow">
            <div className="ant-collapse-header" role="button" tabIndex="0" aria-expanded="true"></div>
            <div className="ant-collapse-content ant-collapse-content-active">
              <div className="ant-collapse-content-box" style={{ padding: 16 }}>
                <div
                  style={{
                    display: "flex",
                    "-webkit-box-pack": "end",
                    justifyContent: "flex-end",
                    marginRight: "100px",
                  }}
                >
                  <Button disabled={step3Loading} kind="secondary" onClick={onCancel}>
                    <FormattedMessage id="validation.actions.cancel" />
                  </Button>
                  {step2Completed && (
                    <Button
                      disabled={step3Loading}
                      style={{
                        margin: "0px 0 0 10px",
                      }}
                      kind="secondary"
                      onClick={() => {
                        setStep1Completed(false);
                        setStep2Completed(false);
                        setAllStepFilled(false);
                        window.scroll(0, 0);
                      }}
                    >
                      <FormattedMessage id="validation.actions.edit" />
                    </Button>
                  )}
                  <Popconfirm
                    placement="topRight"
                    title={intl.formatMessage({ id: "validation.confirm" })}
                    onConfirm={() => confirmSubmit()}
                    okText={intl.formatMessage({ id: "generic.yes" })}
                    cancelText={intl.formatMessage({ id: "generic.no" })}
                  >
                    <Button
                      disabled={!allStepFilled || step3Loading}
                      style={{
                        minWidth: "100px",
                        margin: "0px 10px",
                      }}
                    >
                      <FormattedMessage id="validation.actions.submit" />
                      {step3Loading && <FontAwesomeIcon style={{ marginLeft: 8, fontSize: 16 }} spin icon={["far", "circle-notch"]} />}
                    </Button>
                  </Popconfirm>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudioCertificationForm;
